// Maps the standard error envelope (spec §31) to a typed JavaScript
// error. Mirrors `ApiException` from the mobile app so the same wire
// surface can be consumed in the browser.
export interface ApiErrorDetails {
  [key: string]: unknown;
}

export class ApiException extends Error {
  readonly statusCode: number;
  readonly code: string;
  readonly details: ApiErrorDetails | null;

  constructor(params: {
    statusCode: number;
    code: string;
    message: string;
    details?: ApiErrorDetails | null;
  }) {
    super(params.message);
    this.name = 'ApiException';
    this.statusCode = params.statusCode;
    this.code = params.code;
    this.details = params.details ?? null;
  }

  static async fromResponse(res: Response): Promise<ApiException> {
    let code = 'INTERNAL_ERROR';
    let message = `Request failed with status ${res.status}`;
    let details: ApiErrorDetails | null = null;
    try {
      const body = (await res.json()) as {
        error?: { code?: string; message?: string; details?: ApiErrorDetails };
      };
      if (body.error) {
        code = body.error.code ?? code;
        message = body.error.message ?? message;
        details = body.error.details ?? null;
      }
    } catch {
      // Non-JSON body — fall back to status-text.
      if (res.statusText) message = res.statusText;
    }
    return new ApiException({ statusCode: res.status, code, message, details });
  }
}
